import React from 'react';
import PropTypes from 'prop-types';
import { gettext } from 'utils/text';

const Preview = ({ url, title, subtitle, description, image }) => (
    <div className="featured__item">
        <div className="featured__content">
            <a href={url}>
                <h2 className="mb-0">{title}</h2>
            </a>
            <p className="subtitle">{subtitle}</p>
            <p className="description">{description}</p>
            <a href={url} className="link">
                {gettext('Read more')}
            </a>
        </div>
        <div className="featured__image">
            <a
                href={url}
                className="featured__image__image"
                style={image ? { backgroundImage: `url('${image}')` } : null}
            >
                &nbsp;
            </a>
        </div>
    </div>
);

Preview.propTypes = {
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
};

export default Preview;



// WEBPACK FOOTER //
// ./src/components/Preview.js